export default __webpack_public_path__ + "static/media/map-marker.5e55ec00.svg";